export const NAME = 'product-thumbnail';

export const ALLOWED_EXTENSIONS = 'image/png,image/jpeg,image/jpg';
